import { ClientPanels, ClientTabs } from "slot-definitions"
import { SecureTab, SecureTabPanel } from "minimals-template/components/secure-tabs"

import { Lazy } from "lib/make-lazy"
import { Frag } from "lib/@components/slot/frag"

ClientTabs.plug(
    <SecureTab demand="admin-debug" label="Debug" value="Debug" priority={1020} hide={true} fallback={<Frag />} />
)

ClientPanels.plug(
    <SecureTabPanel value="Debug" demand="admin-debug" hide={true} fallback={<Frag />}>
        <Lazy
            importer={() => import("routes/sfg20-admin/plugins/companies-tab/tabs/debug/debug-licences.ui")}
            extract="LicenseInfo"
            label={"LicenseInfo"}
        />
    </SecureTabPanel>
)
